import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import API from '../../../utils/API';
import LoadingWizard from '../../../components/spinner/wizard';
import logo from '../../../assets/img/logos/simple events logo.png';
import InputField from '../../../components/inputs/inputField';
import ShareablePageModule from '../../../components/views/ShareablePageModule';

const ENV =
    process.env.NODE_ENV === 'production'
        ? window.location.href.includes('planner.simple.events') ? `https://admin-api.simple.events/` : `https://beta-api.simple.events/`
        : `http://${window.location.hostname}:5015/`;

class EventSharedPage extends Component {
    constructor(props) {
        super(props);
        const pageId = props.match.params.page;
        const eventId = props.match.params.event;
        const orgId = props.match.params.organization;
        let authentication = localStorage.getItem('authentication');
        authentication = authentication ? JSON.parse(authentication) : {};
        const valid = authentication.expiry && new Date(authentication.expiry) > Date.now();
        this.state = {
            page: {},
            event: {
                attendees: [],
                sessions: [],
                groups: [],
                emails: [],
                texts: [],
                forms: [],
                pages: [],
                submissions: [],
            },
            expired: !valid,
            encryptedCode: '',
            email: '',
            fullName: '',
            authenticatedUser: {
                email: '',
                fullName: '',
                _id: ''
            },
            error: '',
            emailError: '',
            fullNameError: '',
            emailCode: '',
            codeError: '',
            pageId,
            orgId,
            eventId,
            loading: true,
            codeRequested: false,
            feedbackThreads: [],
        };
    }

    async componentDidMount() {
        const { pageId, eventId, orgId, expired } = this.state;

        // Load stored user data from localStorage
        const storedUserData = localStorage.getItem('authenticatedUser');
        if (storedUserData) {
            try {
                const userData = JSON.parse(storedUserData);
                this.setState({
                    authenticatedUser: userData,
                    email: userData.email,
                    fullName: userData.fullName
                });
            } catch (e) {
                console.log('Error parsing stored user data:', e);
            }
        }

        if (!expired) {
            await this.loadPage();
        }
    }

    verifyEmail = async () => {
        const { email, fullName, pageId, orgId } = this.state;

        // Check if email and fullName are required and defined
        let emailError = '';
        let fullNameError = '';

        if (!email) {
            emailError = 'Email is required';
        }
        if (!fullName) {
            fullNameError = 'Full name is required';
        }

        if (emailError || fullNameError) {
            this.setState({ emailError, fullNameError });
            return;
        }

        try {
            const res = await API().post(`Organizations/${orgId}/platformActions/eventPageAccess/${pageId}`, { requestorEmail: email.toLowerCase(), requestorFullName: fullName });
            if (res.data) {
                let sharedUser = res.data.sharedUser;
                this.setState({ codeRequested: true, emailError: '', fullNameError: '', encryptedCode: res.data.ec, authenticatedUser: sharedUser });
            }
        } catch (e) {
            this.setState({ emailError: 'Access Denied', fullNameError: '' });
        }
    }

    submitCode = async () => {
        const { emailCode, email, fullName } = this.state;
        try {
            const validCode = this.validateCode(emailCode);
            if (validCode) {
                localStorage.setItem('authentication', JSON.stringify({ expiry: new Date(Date.now() + 1000 * 60 * 60 * 24 * 7) }));

                // Store user data in localStorage
                const userData = { ...this.state.authenticatedUser };
                localStorage.setItem('authenticatedUser', JSON.stringify(userData));

                this.setState({
                    expired: false,
                    error: '',
                    codeError: '',
                    authenticatedUser: userData
                }, this.loadPage);
            } else {
                this.setState({ codeError: 'Invalid Code', error: '' });
            }
        } catch (e) {
            console.log(e)
            this.setState({ error: 'Access Denied' });
        }
    }

    loadPage = async () => {
        const { pageId, eventId, orgId } = this.state;
        try {
            const res = await API().get(`Organizations/${orgId}/events/${eventId}/shareablePage/${pageId}/`);
            if (res.data) {
                const page = res.data.page;
                const feedbackThreads = res.data.feedbackThreads || [];
                const sharedWith = res.data?.page?.sharedWith || [];

                this.setState({ page: page, loading: false, feedbackThreads: feedbackThreads });
            }
        } catch (e) {
            console.log(e);
        }
    }

    validateCode = (code) => {
        const key = this.state.pageId.toString();
        const encryptedCode = this.state.encryptedCode;
        let decrypted = [...encryptedCode].map((char, index) => {
            const shift = key.charCodeAt(index % key.length);
            return String.fromCharCode(char.charCodeAt(0) - shift);
        }).join('');
        return decrypted === code;
    }

    closeReport = () => {
        localStorage.removeItem('authentication');
        localStorage.removeItem('authenticatedUser');
        window.location.reload();
    }

    /* Ill be housing all feedback related functions here */

    addNewThread = async (newThread, callback) => {
        const { page, pageId, eventId, orgId } = this.state;
        const payload = {
            ...newThread
        };

        try {
            const res = await API().post(`Organizations/${orgId}/events/${eventId}/shareablePage/${pageId}/post-thread`, payload);
            if (res.data) {
                const savedThread = res?.data.thread;
                const feedbackThreads = [...this.state.feedbackThreads, savedThread];
                this.setState({ page: page, loading: false, feedbackThreads: feedbackThreads }, () => {
                    if (callback) {
                        callback();
                    }
                });
            }
        } catch (e) {
            console.log(e);
        }
    }

    patchThread = async (threadId, updatedThread, callback) => {
        const { page, pageId, eventId, orgId } = this.state;
        const payload = {
            ...updatedThread
        };

        try {
            const res = await API().patch(`Organizations/${orgId}/events/${eventId}/shareablePage/${pageId}/thread/${threadId}`, payload);
            if (res.data) {
                const updatedThread = res?.data.thread;
                let feedbackThreads;

                if (payload?.deleted === true) {
                    feedbackThreads = this.state.feedbackThreads.filter(thread => thread._id !== threadId);
                } else {
                    feedbackThreads = this.state.feedbackThreads.map(thread => {
                        if (thread._id === updatedThread._id) {
                            return updatedThread;
                        }
                        return thread;
                    });
                }

                this.setState({ page: page, loading: false, feedbackThreads: feedbackThreads }, () => {
                    if (callback) {
                        callback();
                    }
                });
            }
        } catch (e) {
            console.log(e);
        }
    }

    render() {
        const {
            page,
            event,
            eventId,
            orgId,
            loading,
            expired,
            codeRequested,
            authenticatedUser
        } = this.state;

        return (
            <Fragment>
                {!loading && <div className='pageContainer' style={{ height: 'calc(100% - 51px)' }}>
                    <ShareablePageModule
                        isOpen={true}
                        page={page}
                        orgId={orgId}
                        eventId={eventId}
                        keyedMetadata={[]}
                        keyedData={{}}
                        event={{}}
                        branding={event.branding}
                        url={`${ENV}Organizations/${orgId}/events/${eventId}/pages/render/${page._id}`}
                        method={{}}
                        postData={{}}
                        toggle={() => { }}
                        update={this.updatePageHtml}
                        cancelEdit={this.cancelEdit}
                        links={{
                            getAssets: `Organizations/${orgId}/events/${eventId}/assets`,
                            addAssets: `Organizations/${orgId}/events/${eventId}/assets`,
                        }}
                        authenticatedUser={authenticatedUser}
                        addNewThread={this.addNewThread}
                        feedbackThreads={this.state.feedbackThreads}
                        patchThread={this.patchThread}
                        closeReport={this.closeReport}
                    />
                </div>}

                <LoadingWizard loading={loading && !expired} text="Loading Page" />
                {expired && <div className="flex column aic jcc h-100">
                    <div className='flex column inputCard'>
                        <h1 className='mb-10'>Event Page</h1>
                        <p className='mb-20'>{!codeRequested ? 'Please enter your email address to view this Page.' : 'A code was sent to the email entered, enter it below to view this Page.'}</p>
                        <InputField
                            label={'Full Name'}
                            type={'text'}
                            value={this.state.fullName}
                            classes={`mb-20 ${codeRequested ? 'gray' : ''}`}
                            disabled={codeRequested}
                            onChange={(e) => this.setState({ fullName: e.target.value })}
                            placeholder={'Enter your full name'}
                            inputIcon={codeRequested ? <i className='la las-lock' /> : null}
                            errorTrigger={this.state.fullNameError !== ''}
                            errorMessage={this.state.fullNameError}
                            required={true}
                        />
                        <InputField
                            label={'Email'}
                            type={'email'}
                            value={this.state.email}
                            classes={`mb-20 ${codeRequested ? 'gray' : ''}`}
                            disabled={codeRequested}
                            onChange={(e) => this.setState({ email: e.target.value })}
                            placeholder={'Enter email'}
                            inputIcon={codeRequested ? <i className='la las-lock' /> : null}
                            errorTrigger={this.state.emailError !== ''}
                            errorMessage={this.state.emailError}
                            required={true}
                        />
                        {codeRequested && <InputField
                            label={'Code'}
                            type={'text'}
                            value={this.state.emailCode}
                            classes="mb-20"
                            onChange={(e) => this.setState({ emailCode: e.target.value })}
                            placeholder={'Enter code received in email'}
                            errorTrigger={this.state.codeError !== ''}
                            errorMessage={this.state.codeError}
                        />}
                        <button className="ml-a neu prim" onClick={() => !codeRequested ? this.verifyEmail() : this.submitCode()}>
                            Continue
                        </button>
                    </div>
                </div>}
            </Fragment>
        );
    }
}

export default withRouter(EventSharedPage);
